namespace app.services.tagging {

  export class TagFormElementDataService {
    private resourceWrapperService: ResourceWrapperService;
    private configService: app.services.IConfigService;
    private itemResource;

    constructor($resource: angular.resource.IResourceService, configService: app.services.IConfigService, resourceWrapperService: ResourceWrapperService) {
      this.resourceWrapperService = resourceWrapperService;
      this.configService = configService;

      let rawItemResource = $resource(`${this.configService.getServerBaseUrlForResource()}/project/:projectId/collection/:collectionId/resource/:resourceId/formdata/:id`,
        {id: "@id", projectId: "@projectId", collectionId: "@collectionId", resourceId: "@resourceId"},
        {
          update: {method: "PUT"}
        }
      );

      this.itemResource = this.resourceWrapperService.WrapActions(rawItemResource);
    }

    public Get(projectId: string, collectionId: string, resourceId: string, id: string): Promise<any> {
      return this.itemResource.query({
        projectId,
        collectionId,
        resourceId,
        id
      }).$promise;
    }

    public Save(projectId: string, collectionId: string, resourceId: string, item: { tagFormElementId: string, value: string }): Promise<any> {
      const itemResource = new this.itemResource({projectId, collectionId, resourceId, ...item});
      return itemResource.$save();
    }

    public Delete(projectId: string, collectionId: string, resourceId: string, id: string): Promise<any> {
      return this.itemResource.delete({
        projectId,
        collectionId,
        resourceId,
        id
      }).$promise;
    }
  }

  frontendApp.factory("TagFormElementDataService", ['$resource', 'ConfigService', 'ResourceWrapperService', function(resource, configService, resourceWrapperService) {
    return new TagFormElementDataService(resource, configService, resourceWrapperService);
  }]);
}
